<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('campaign-home')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Add Campaign</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <p>Campaign Heading</p>
        <base-input
          alternative
          class="mb-3"
          name="Heading"
          :rules="{ required: true }"
          placeholder="Heading"
          v-model="heading"
        >
        </base-input>
        <div class="flex items-center space-x-4">
          <!-- Start Date -->
          <div class="flex flex-col">
            <label for="startDate" class="mb-1 text-sm font-medium"
              >Start Date:</label
            >
            <el-date-picker
              v-model="startDate"
              type="date"
              placeholder="Pick a date"
              format="dd-MM-yyyy"
              value-format="yyyy-MM-dd"
              class="w-40"
            />
            <span v-if="startDateErr" class="text-sm text-danger">{{
              msg.startDate
            }}</span>
          </div>

          <!-- End Date -->
          <div class="flex flex-col">
            <label for="endDate" class="mb-1 text-sm font-medium"
              >End Date:</label
            >
            <el-date-picker
              v-model="endDate"
              type="date"
              placeholder="Pick a date"
              format="dd-MM-yyyy"
              value-format="yyyy-MM-dd"
              class="w-40"
              :picker-options="endDatePickerOptions"
            />
            <span v-if="endDateErr" class="text-sm text-danger">{{
              msg.endDate
            }}</span>
          </div>
        </div>

        <div
          class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block mt-5"
        >
          Recommended Size: 1400px × 450px
        </div>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        <Cropper
          class="cropper"
          :src="image"
          v-if="coverImage != ''"
          @change="handleCropperChange"
          ref="cropper"
        />
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>

        <img v-if="image" :src="image" ref="cover" />

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";
import "vue-advanced-cropper/dist/style.css";
import { Cropper } from "vue-advanced-cropper";
// import Data from "../../../../../admin/pages/add-product/components/Data";

export default {
  components: {
    FileUploader,
    quillEditor,
    Cropper,
  },
  data() {
    return {
      heading: "",
      link: "",
      image: null,
      startDate: null,
      endDate: null,
      startDateErr: false,
      endDateErr: false,

      cropperImg: "",
      coverImage: null,
      content: "",
      btnName: "",
      editorOption: {
        theme: "snow",
      },
      linkErr: false,
      imageErr: false,
      msg: {
        image: "",
        date: "",
      },
    };
  },
  computed: {
    // ...mapState("cms", {
    //   pageCategories: "pageCategories",
    //   selectedpagecategory: "selectedpagecategory",
    // }),
    ...mapState("campaignPageBanner", { campaignHome: "campaignHome" }),
    endDatePickerOptions() {
      return {
        disabledDate: (date) => {
          return this.startDate
            ? date.getTime() < new Date(this.startDate).getTime()
            : false;
        },
      };
    },
  },
  methods: {
    handleCropperChange(img) {
      // console.log(img);
      this.cropperImg = this.$refs.cropper.getResult().canvas.toDataURL();
      this.coverImage = this.dataURLtoFile(img.canvas.toDataURL(), "image.png");
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },

    async onSubmit() {
      this.startDateErr = false;
      this.endDateErr = false;
      this.msg.startDate = "";
      this.msg.endDate = "";

      if (!this.startDate) {
        this.startDateErr = true;
        this.msg.startDate = "Start Date is required";
      }

      if (!this.endDate) {
        this.endDateErr = true;
        this.msg.endDate = "End Date is required";
      }

      if (this.startDateErr || this.endDateErr) {
        return;
      }
      let FormData = require("form-data");
      let data = new FormData();

      data.append("heading", this.heading);
      data.append("image", this.coverImage);
      data.append("startDate", this.startDate);
      data.append("endDate", this.endDate);

      let loader = this.$loading();

      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      try {
        const newsdata = await this.$store.dispatch(
          "campaignPageBanner/add_campaignhome",
          data
        );

        if (newsdata.code == 200) {
          this.$router.push({ name: "campaign-home" });
          this.$swal.fire({
            text: "Campaign Successfully Added",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        loader.close();
      } catch (error) {
        if (error.response.status) {
          this.$swal.fire({
            title: "Error",

            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      }
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
